module.exports = __webpack_public_path__ + "static/img/recording_needed.a160632e.svg";